export enum EmailVerificationState {
    UNSUBMITTED = 'UNSUBMITTED',
    PENDING = 'PENDING',
    VERIFIED = 'VERIFIED',
    FAILED = 'FAILED'
}

export interface IEmailVerificationStatus {
    state: EmailVerificationState;
    rejectReason?: string;
}
